module["exports"] = [
  "#{street}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/address/street_name.js
// module id = 210
// module chunks = 0